import { STARTING_CREDITS } from './economy.js';
export const ALL_FACTIONS = [
    'cta',
    'helion',
    'argent',
    'meridian',
    'tycho',
    'vega',
];
export function createDefaultPlayer() {
    return {
        credits: STARTING_CREDITS,
        reputation: {},
        researchPoints: 0,
        lifetimeCredits: 0,
        lifetimeSoldByResource: {},
        purchasedResearch: [],
        lifetimeResearchPoints: 0,
        lifetimeContractsFulfilled: 0,
        subsidiaries: [],
        charterRank: 'junior',
        everProducedResources: [],
        unlockedStationCount: 1,
    };
}
/** Reputation is clamped to this range across every faction. */
export const REPUTATION_MIN = -100;
export const REPUTATION_MAX = 100;
/**
 * Apply a rep delta to a faction, clamped to [REPUTATION_MIN, REPUTATION_MAX].
 * Pure — returns a new reputation map without mutating the input. Callers
 * (contracts, signup, admin quick-actions) merge the returned object back
 * into `player.reputation`.
 */
export function applyReputationDelta(reputation, faction, delta) {
    const current = reputation[faction] ?? 0;
    const next = Math.max(REPUTATION_MIN, Math.min(REPUTATION_MAX, current + delta));
    return { ...reputation, [faction]: next };
}
//# sourceMappingURL=player.js.map